import { gql } from '@apollo/client';

const CONTACT_MUTATION = gql`
  mutation createMessageLog($input: CreateMessageLogInput) {
    createMessageLog(input: $input) {
      result {
        id
        email
      }
    }
  }
`;

export { CONTACT_MUTATION };
